import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { isStandalone, pushState, subscribePush, thisDeviceSubId } from "@/lib/pwa";
import { DENIED_COPY } from "./PushCard";

const FLAG = "dls_push_prompted";

export function FirstOpenPushPrompt() {
  const [open, setOpen] = useState(false);
  const [denied, setDenied] = useState(false);
  useEffect(() => {
    if (isStandalone() && pushState() === "ok" && Notification.permission === "default" && !thisDeviceSubId() && !localStorage.getItem(FLAG)) setOpen(true);
  }, []);
  const close = () => { localStorage.setItem(FLAG, "1"); setOpen(false); };
  const turnOn = async () => {
    try {
      const r = await subscribePush(api);
      if (r.status === "denied") return setDenied(true);
      if (r.status === "ok") toast.success("Notifications turned on for this device");
      close();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-sm bg-card rounded-2xl" data-testid="push-first-open-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl flex items-center gap-2"><Bell className="h-5 w-5" />Turn on notifications</DialogTitle>
          <DialogDescription>Get a pop-up on this device when a bill is due, a budget is reached or a scan needs review.</DialogDescription>
        </DialogHeader>
        {denied && <p className="text-sm text-rose-800" data-testid="push-first-open-denied">{DENIED_COPY}</p>}
        <div className="flex gap-2 justify-end">
          <Button variant="outline" className="rounded-xl" onClick={close} data-testid="push-first-open-later">Not now</Button>
          <Button className="rounded-xl" onClick={turnOn} data-testid="push-first-open-turn-on">Turn on notifications</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
